<template>
  <div class="tool-fliter">
    <div class="season-box">
      <p
        v-for="(item, index) in seasonList"
        :key="item"
        :class="{'active': active === index && !isPicker}"
        @click.stop="checkSeason(index)"
      >
        {{ item }}
      </p>
    </div>
    <wf-date
      placement="bottom"
      type="daterange"
      value-format="yyyy/MM/dd"
      :picker-options="pickerOptions"
      v-model="date"
      @change="changeVal"
    >
    </wf-date>
    <!-- <el-date-picker
      format="yyyy/MM/dd"
      v-model="date"
      :picker-options="pickerOptions"
      size="mini"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change="changeVal"
    >
    </el-date-picker> -->
  </div>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      seasonList: ['周', '月', '季'],
      active: 0,
      date: '',
      isPicker: false,
      pickerOptions: {
        shortcuts: false,
        // shortcuts: [{
        //   text: '一周',
        //   onClick(picker) {
        //     const start = new Date();
        //     const end = new Date();
        //     end.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
        //     picker.$emit('pick', [start, end]);
        //   }
        // }, {
        //   text: '一个月',
        //   onClick(picker) {
        //     const end = new Date();
        //     const start = new Date();
        //     end.setTime(end.getTime() - 3600 * 1000 * 24 * 30);
        //     picker.$emit('pick', [start, end]);
        //   }
        // }, {
        //   text: '三个月',
        //   onClick(picker) {
        //     const end = new Date();
        //     const start = new Date();
        //     end.setTime(end.getTime() - 3600 * 1000 * 24 * 90);
        //     picker.$emit('pick', [start, end]);
        //   }
        // }, {
        //   text: '清空',
        //   cellClassName:'date-cancel del-text text-red',
        //   onClick(picker) {
        //     picker.$emit('pick', '');
        //   }
        // }],
        disabledDate(time) {
          return time.getTime() > new Date(new Date().setDate(new Date().getDate() - 1)).getTime();
        },
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    checkSeason(idx) {
      this.active = idx
      this.isPicker = false
      this.date = ''
      this.$emit('selectTime', this.selectData(idx))
    },
    changeVal() {
      this.isPicker = true
      const _date = this.date ? this.date : this.selectData(0)
      this.$emit('selectTime', _date)
    },
    init() {
      this.$emit('selectTime', this.selectData(this.active))
    },
    selectData(idx) {
      let arr = []
      switch (idx) {
        case 0:
          arr = [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]
          break
        case 1:
          arr = [new Date(new Date().setDate(new Date().getDate() - 30)), new Date()]
          break
        case 2:
          arr = [new Date(new Date().setDate(new Date().getDate() - 90)), new Date()]
      }
      return arr
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.tool-fliter {
  display: flex;
  .el-date-editor {
    width: 233px;
    height: 32px;
  }
  .season-box {
    display: flex;
    width: 84px;
    height: 32px;
    @include bgColorOpacity(.08);
    border-radius: 4px;
    margin-right: 8px;
    padding: 3px;
    box-sizing: border-box;
    p {
      width: 26px;
      height: 26px;
      border-radius: 2px;
      font-size: 14px;
      @include fontColorOpacity(.6);
      text-align: center;
      line-height: 26px;
      cursor: pointer;
      &:hover {
        @include bgColorOpacity(.08);
      }
      &.active {
        @include fontColorOpacity(1);
        background: #fff;
      }
    }
  }
}
</style>
